import React, { useState } from "react";

import { PaziaInput } from "components/atoms";
import { CheckButton } from "components/atoms/Buttons";

interface CreateNewDictionaryValueProps {
  index: number;
  onSubmit: (value: string) => Promise<void>;
}

export const CreateNewDictionaryValue = ({ index, onSubmit }: CreateNewDictionaryValueProps) => {
  const [inputValue, setInputValue] = useState("");

  const onCreate = () => {
    if (!inputValue.trim()) return;
    onSubmit(inputValue);
    setInputValue("");
  };

  return (
    <div>
      <div className="flex">
        <div className="w-[38px] h-[38px] flex items-center justify-center">{index + 1}</div>
        <PaziaInput
          name={`values.${index}.value` as const}
          inputClassName="w-[10rem]"
          value={inputValue}
          onChange={(x) => setInputValue(x.target.value)}
        />
        <div className="my-auto ml-1.5">
          <CheckButton onClick={onCreate} />
        </div>
      </div>
    </div>
  );
};
